module.exports = __webpack_public_path__ + "img/THERMOPROBE.de36ea1e.jpg";